/**
 * 학교명 축약 유틸리티 클래스
 */
class SchoolNameUtils {
  /**
   * 학교명을 축약형으로 변환
   * @param {string} schoolName - 학교명
   * @param {string} schoolLevel - 학교급 (초등학교, 중학교, 고등학교 등)
   * @returns {string} 축약된 학교명
   */
  static getAbbreviation(schoolName, schoolLevel) {
    if (!schoolName || !schoolLevel) {
      return schoolName || '';
    }

    let result = schoolName;
    
    // 1. 분교장 처리 - school_level 다음에 나오는 분교장 텍스트를 괄호로 처리
    const branchPattern = new RegExp(`${schoolLevel}(.+분교장)$`);
    const branchMatch = result.match(branchPattern);
    let branchText = '';
    
    if (branchMatch) {
      branchText = `(${branchMatch[1]})`;
      result = result.replace(branchMatch[0], schoolLevel);
    }
    
    // 2. school_level 제거
    if (result.endsWith(schoolLevel)) {
      result = result.slice(0, -schoolLevel.length);
    }
    
    // 3. 특수 단어 축약 처리
    const abbreviations = {
      '여자': '여',
      '상업': '상',
      '공업': '공'
    };
    
    for (const [full, abbr] of Object.entries(abbreviations)) {
      if (result.includes(full)) {
        result = result.replace(full, abbr);
      }
    }
    
    // 4. school_level의 첫 글자 추가
    if (schoolLevel && schoolLevel.length > 0) {
      result += schoolLevel.charAt(0);
    }
    
    // 5. 분교장 텍스트 추가
    result += branchText;
    
    return result;
  }

  /**
   * 학교 리스트에서 검색어에 매칭되는 학교들을 필터링
   * @param {Array} schools - 학교 리스트
   * @param {string} searchTerm - 검색어
   * @returns {Array} 필터링된 학교 리스트
   */
  static filterSchools(schools, searchTerm) {
    if (!searchTerm || searchTerm.trim() === '') {
      return [];
    }
    
    const term = searchTerm.toLowerCase().trim();
    
    return schools.filter(school => {
      const schoolName = school.school_name.toLowerCase();
      const abbreviation = this.getAbbreviation(school.school_name, school.school_level).toLowerCase();
      
      // 학교명 또는 축약명에서 검색
      return schoolName.includes(term) || abbreviation.includes(term);
    });
  }

  /**
   * 학교명 유효성 검사
   * @param {string} schoolName - 입력된 학교명
   * @param {Array} schools - 학교 리스트
   * @returns {boolean} 유효한 학교명인지 여부
   */
  static isValidSchool(schoolName, schools) {
    return schools.some(school => school.school_name === schoolName);
  }
}

export default SchoolNameUtils;